import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Main,
  SideBar,
  Span,
} from "../Styles/Global.Styled";
import PageHeader from "../Components/PageBanner/PageHeader";
import Filter from "../Components/Filters/Filter";
import { css } from "styled-components";
import ProductAd from "../Components/Product/ProductAd";
import ShopCarousel from "../Components/Carousel/ShopCarousel";
import FilterSortIcon from "../Icons/FilterSortIcon";
import { getAvailableFilters, getStoreProducts } from "../api/product";
import { shopFilters } from "../helpers/data";
import MobileFilterBar from "../Components/Filters/MobileFilterBar";

const openFilterBttn = css`
  font-family: "";
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.5vh;
  padding: 0.5vh 0;
  border-bottom: 1px solid lightgrey;
  gap: 8vh;
  align-self: start;
  margin: 2vh 7vw 1vh;
`;
const hiddenFltBttn = css`
  display: flex;
  font-size: 1.25vh;
  padding: 0.75vh 1vh;
  border: 1px solid lightgrey;
  border-radius: 25px;
  align-self: flex-start;
  margin: 2vh 7vw;
  gap: 2vh;
`;
const spanStyle = css`
  font-size: 1vh;
  color: grey;
  font-weight: 200;
  font-style: italic;
  text-decoration: underline;
`;
const SideBarStyle = (fltrOpen) => css`
  flex-direction: column;
  display: ${fltrOpen ? "flex" : "none"};
  gap: 1vh;
  width: 12%;
  border-right: 1px solid lightgrey;
  padding-right: 2vh;
`;
const displayHide = css`
  display: none;
`;
const paddingStyle = css`
  padding: 0vh 7vw 10vh;
`;
const gapStyle = css`
  gap: 0.5vh;
`;

const Shop = ({ fltrBarProps, setFltrBar }) => {
  const [products, setProducts] = useState([]);
  const [fltr, setFilters] = useState(shopFilters);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await getStoreProducts(fltr);
        setProducts(res);
      } catch (error) {}
    };
    fetchProduct();
  }, [fltr]);

  useEffect(() => {
    const fetchAvailableFilters = async () => {
      try {
        const resFilters = await getAvailableFilters();

        const updatedFilters = shopFilters.map((filter) => {
          if (filter.type === "selection" && resFilters[filter.productAtt]) {
            const available = resFilters[filter.productAtt];

            return {
              ...filter,
              selections: filter.selections?.map((s) => ({
                ...s,
                disabled: !available.includes(s.name),
              })),
            };
          }

          if (filter.type === "range" && resFilters[filter.productAtt]) {
            return {
              ...filter,
              min: resFilters[filter.productAtt].min,
              maxValue: resFilters[filter.productAtt].max,
              minValue: resFilters[filter.productAtt].min,
              max: resFilters[filter.productAtt].max,
            };
          }

          return filter;
        });
        setFilters(updatedFilters);
      } catch (error) {}
    };
    fetchAvailableFilters();
  }, []);

  return (
    <Main>
      <PageHeader header={"Shop"} />
      <Button
        $baseStyle={fltrBarProps.isDesktopOpen ? openFilterBttn : hiddenFltBttn}
        onClick={() =>
          setFltrBar({
            isOpen: !fltrBarProps.isOpen,
            content: (
              <MobileFilterBar
                fltr={fltr}
                setFilters={setFilters}
                setProducts={setProducts}
                setPopUp={setFltrBar}
              />
            ),
            mobileOnly: true,
            isDesktopOpen: !fltrBarProps.isDesktopOpen,
            isCustom: "filterBar",
          })
        }
      >
        <Container $baseStyle={gapStyle}>
          <FilterSortIcon /> Filters & Sort
        </Container>
        <Span $baseStyle={spanStyle} $mStyle={displayHide}>
          {fltrBarProps.isDesktopOpen ? "hide" : "show"}
        </Span>
      </Button>
      <Container $baseStyle={paddingStyle}>
        <SideBar
          $baseStyle={SideBarStyle(fltrBarProps.isDesktopOpen)}
          $mStyle={displayHide}
        >
          {fltr?.map((filterType, index) => (
            <Filter
              key={filterType.name}
              isOpen={[0, 1].includes(index)}
              filterType={filterType}
              setFilters={setFilters}
              setProducts={setProducts}
              index={index}
            />
          ))}
        </SideBar>
        <ShopCarousel items={products} Component={ProductAd} />
      </Container>
    </Main>
  );
};

export default Shop;
